import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export const FOLIO_MAX_LENGTH = 15;

/** Elimina cualquier carácter de espacio en blanco del folio. */
export function normalizarFolioInput(valor: string | null | undefined): string {
  return String(valor ?? '').replace(/\s/g, '');
}

/** Rechaza folios que contengan espacios en blanco. */
export const folioSinEspaciosValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const raw = String(control.value ?? '');
  if (!raw) return null;
  return /\s/.test(raw) ? { folioSinEspacios: true } : null;
};

/** Validadores del folio en registro de visita (digital o papel). */
export function folioRegistroValidators(): ValidatorFn[] {
  return [Validators.required, Validators.maxLength(FOLIO_MAX_LENGTH), folioSinEspaciosValidator];
}

/** Normaliza el valor del control folio mientras el usuario escribe. */
export function aplicarEntradaFolio(
  control: AbstractControl | null | undefined,
  valorEntrada: string | null | undefined
): void {
  const normalizado = normalizarFolioInput(valorEntrada);
  if (control && control.value !== normalizado) {
    control.setValue(normalizado, { emitEvent: false });
  }
}
